import React from "react";
import {Card, CardBody, Spacer} from "@nextui-org/react";

const Intro = () => {

    return (
        <div className="grid grid-cols-1 lg:grid-cols-2">
            {/* Left side (card) */}
            <Card
                className="bg-transparent h-auto lg:h-[650px]"
                isBlurred={false}
                shadow="none"
            >
                <CardBody className="
                  flex flex-col
                  justify-center
                  items-start
                  px-6 py-8   /* Smaller screens */
                  sm:px-12 sm:py-12
                  lg:px-20
                ">
                    <h2 className="text-2xl sm:text-3xl lg:text-3xl font-bold">
                        Spezialist für zukunftsfähiges Energiemanagement
                    </h2>
                    <Spacer y={2}/>
                    <h4 className="text-base sm:text-lg lg:text-xl text-white/90">
                        Von der Datenerfassung und -analyse über intelligente Steuerung und Visualisierung bis
                        hin zum umfassenden Energie-Reporting: Wir bieten Ihnen eine ganzheitliche Komplettlösung.
                        Dabei decken wir nicht nur Ihre Energieverbräuche und Einsparpotenziale auf,
                        sondern setzen Optimierungen direkt um und erzielen messbare Kosteneinsparungen.
                        So stärken wir Ihre Wettbewerbsfähigkeit und sichern Ihren wirtschaftlichen Erfolg.
                    </h4>
                    {/*<Spacer y={5}/>*/}
                    {/*<Button color="primary">Kontakt aufnehmen</Button>*/}
                </CardBody>
            </Card>

            {/* Right side (image or content) */}
            <div className="bg-gray-200 h-auto lg:h-[650px]">
                {/* e.g. an <Image /> or something else */}
            </div>
        </div>
    )
}

export default Intro;
